import { useShallow } from 'zustand/shallow'

import { Button } from '@/components/atoms/Button'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/atoms/Dialog'
import { useScopedI18n } from '@/locales/client'
import type { DialogTypes } from '@/stores/DialogsStore'
import useDialogsStore from '@/stores/DialogsStore'

const DIALOG_ID: DialogTypes = 'portExpanderDisabled'

function PortExpanderDialog() {
  const t = useScopedI18n('dialogs.portExpander')
  const { open } = useDialogsStore(useShallow(state => state.dialogs.portExpanderDisabled))
  const toggle = useDialogsStore(useShallow(state => state.toggle))

  const handleToggle = () => toggle(DIALOG_ID)

  return (
    <Dialog open={open} onOpenChange={() => toggle(DIALOG_ID)}>
      <DialogContent className="flex flex-col items-center justify-center gap-8 p-12 text-center">
        <DialogTitle>
          <h3 className="text-2xl font-bold leading-snug text-rsf-black">
            {t('title')}
          </h3>
        </DialogTitle>
        <DialogDescription asChild>
          <p className="text-xl font-normal leading-snug text-rsf-black">
            {t('subtitle')}
          </p>
        </DialogDescription>

        <Button className="mt-8" onClick={handleToggle}>
          {t('confirmButton')}
        </Button>
      </DialogContent>
    </Dialog>
  )
}

export default PortExpanderDialog
